import type { useBloomSectionModel } from '@/components/home/components/bloom-section/bloom-section.model'

type BloomSectionViewProps = ReturnType<typeof useBloomSectionModel>

export function BloomSectionView({
  sectionId,
  headlineText,
  stageInert,
  headlineStyle,
}: BloomSectionViewProps) {
  return (
    <section className="fz-bloom" id={sectionId}>
      <div className="fz-bloom__stage" inert={stageInert || undefined}>
        <p className="fz-bloom__headline" style={headlineStyle}>
          {headlineText}
        </p>
      </div>
    </section>
  )
}
